// import React from 'react'
import ReactDOM from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import AppBootstrapProviders from '@/app/bootstrap/providers'
import { getRouter } from './router'
import '@/app/i18n/init' // for i18n initialization

const router = getRouter()

const rootElement = document.getElementById('app')!

if (!rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <AppBootstrapProviders>
      <RouterProvider router={router} />
    </AppBootstrapProviders>
  )
}
